export { default } from './Buyings';
